import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Row, Col, Button } from '_zari/core'

import { TiposSocioConstant } from 'constants/index'

import * as AsientosContablesServices from 'services/asientosContables.service'

import { DownloadAxiosFile } from 'utils'

import * as FormGroups from './formGroups'

const HistorialCuentaPendiente = () => {
  const __zariContext = React.useContext(ZariContext)

  const [tipoSocio, setTipoSocio] = React.useState(TiposSocioConstant.CLIENTE)
  const [nombreSocio, setNombreSocio] = React.useState('')
  const [idSocio, setIdSocio] = React.useState('')
  const [cuentaContable, setCuentaContable] = React.useState('')
  const [consultado, setConsultado] = React.useState(false)

  const onChangeTipoSocio = React.useCallback(val => {
    setTipoSocio(val)
    setNombreSocio('')
    setIdSocio('')
    setCuentaContable('')
  }, [])

  const onChangeSocio = React.useCallback(selectedSocio => {
    setNombreSocio(selectedSocio.label)
    setIdSocio(selectedSocio.value)
    setCuentaContable('')
  }, [])

  const clickClear = React.useCallback(() => {
    setNombreSocio('')
    setIdSocio('')
    setCuentaContable('')
  }, [])

  const onChangeCuenta12 = React.useCallback(val => {
    setCuentaContable(val)
  }, [])

  const clickDescargarReporte = React.useCallback(() => {
    if (!idSocio) {
      __zariContext.snack('error', 'Seleccionar socio')
      return
    }

    if (!cuentaContable) {
      __zariContext.snack('error', 'Seleccionar cuenta contable')
      return
    }

    __zariContext.loader.open('Descargando reporte historial estados financieros')
    AsientosContablesServices.descargarReporteHistorialCuentasCorrientes({ idSocio, cuentaContable })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, idSocio, cuentaContable])

  return (
    <Portlet className='zari-slim-form'>
      <Portlet.Header title='Reporte Historial Cuentas Pendientes' />
      <Portlet.Body>
        <Row>
          <Col md={4}>
            <FormGroups.TipoSocioFormGroup iValue={tipoSocio} onChange={onChangeTipoSocio} />
          </Col>
          <Col md={8}>
            <FormGroups.SocioFormGroup tipoSocio={tipoSocio} nombreSocio={nombreSocio} onChange={onChangeSocio} clickClear={clickClear} />
            <FormGroups.Cuenta12FormGroup
              idSocio={idSocio}
              consultado={consultado}
              setConsultado={setConsultado}
              onChange={onChangeCuenta12}
              value={cuentaContable}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(HistorialCuentaPendiente)
